module.exports = __webpack_public_path__ + "static/media/IMG20221103161759.d2df9ad6.jpg";